import React from "react";

import { NumberInput, required, minValue, maxValue, number } from "react-admin";

const BasicFormatFields = props => (
  <div className="form-row">
    <div className="w-100 w-45-m">
      <NumberInput
        source="message_format[value_bytes]"
        label="Value length"
        className="m-0"
        fullWidth
        validate={[required(), number(), minValue(2), maxValue(24)]}
        {...props}
      />
    </div>
    <div className="w-100 w-45-m">
      <NumberInput
        source="message_format[value_count]"
        label="Number of values"
        className="m-0"
        fullWidth
        validate={[required(), number(), minValue(1), maxValue(12)]}
        {...props}
      />
    </div>
  </div>
);

export default BasicFormatFields;
